import * as firebase from 'firebase/app';
import '@firebase/database';
import '@firebase/storage';
import '@firebase/auth';

const app = firebase.initializeApp(process.env.FIREBASE_CONFIG);

export const database = app.database();
export const auth = app.auth();
export const storage = app.storage();
export const googleAuthProvider = new firebase.auth.GoogleAuthProvider();

// since the server functions are hosted in the same project as the dashboard app, we
// can use the same origin URL and configure path redirects using firebase.json
export const functionsURL = process.env.FUNCTIONS_URL || window.location.origin;
